import React, { useEffect, useRef, useState } from 'react';

import ContactIcon from 'bundles/backoffice/contacts/icon';
import useOnScreen from 'hooks/use_on_screen';

import type { ContactRole } from 'bundles/backoffice/contacts/types';

export interface Props {
  contactRole: ContactRole;
  hasSiblingAbove?: boolean;
  hasSiblingBelow?: boolean;
}

export function ContactsCardContactIcon({ contactRole, hasSiblingAbove, hasSiblingBelow }: Props) {
  const avatarRef = useRef<HTMLSpanElement>(null);
  const isOnScreen = useOnScreen(avatarRef);
  const [avatarCenter, setAvatarCenter] = useState<{ x: number, y: number } | null>(null);

  useEffect(() => {
    if (avatarRef.current && isOnScreen) {
      setAvatarCenter({
        x: avatarRef.current.offsetLeft + avatarRef.current.offsetWidth / 2,
        y: avatarRef.current.offsetTop + avatarRef.current.offsetHeight / 2,
      });
    }
  }, [isOnScreen]);

  let connectorStyle: React.CSSProperties | undefined;
  if (avatarCenter) {
    if (hasSiblingAbove && hasSiblingBelow) {
      connectorStyle = { top: 0, bottom: 0 };
    } else if (hasSiblingAbove) {
      connectorStyle = { top: 0, height: avatarCenter.y };
    } else if (hasSiblingBelow) {
      connectorStyle = { bottom: 0, height: avatarCenter.y };
    }
  }

  return <>
    {avatarCenter && connectorStyle &&
      <div
        className="contact-card__connector position-absolute z-1"
        style={{ ...connectorStyle, left: avatarCenter.x, width: 1 }}
      />
    }

    <ContactIcon className="z-2" contact={contactRole.contact} ref={avatarRef} />
  </>;
}
